import newIntegration from './component'

export default newIntegration
